import { settings } from '@pixi/settings';
export { settings } from '@pixi/settings';
import { ENV } from '@pixi/constants';
settings.PREFER_ENV = ENV.WEBGL2;
settings.STRICT_TEXTURE_CACHE = false;